export function optimizedLogoUrl(value) {
  const url = String(value || '/logo.webp');
  return url === '/logo.png' ? '/logo.webp' : url;
}

export function optimizedProductImageUrl(value) {
  const url = String(value || '');
  if (url === '/side-hustle-validation-lab-cover.png') {
    return '/assets/side-hustle-validation-lab/app-first-command-center.webp';
  }
  return url;
}
